/**
 * V6 database shape. Persisted as `data/db.json`.
 *
 * Breaking from V5:
 *   - adds `version: 6`
 *   - consolidates `bot` + `halloweenMode` under `config`
 *   - `config.owners` is derived on load but can be overridden by the user
 */
import { z } from "zod";
import { TrackSchema } from "./tracks.js";
export const DbConfigSchema = z.object({
    owners: z.array(z.string()).default([]),
    halloweenMode: z.boolean().default(false),
    discord: z
        .object({
        allowedChannelId: z.string().nullable(),
    })
        .default({ allowedChannelId: null }),
    lastGitSyncAt: z.number().int().nullable().default(null),
    /** Last user-driven library change (upload, delete, Spotify import). */
    lastLibraryMutationAt: z.number().int().nullable().default(null),
    /** Last successful push of library → git backup repo. */
    lastGitBackupAt: z.number().int().nullable().default(null),
    /** Last successful restore pull from git backup repo. */
    lastGitRestoreAt: z.number().int().nullable().default(null),
    /** Server-authoritative loudness normalization (shared by browser + Discord). */
    normalization: z
        .object({
        enabled: z.boolean().default(false),
        preampDb: z.number().min(-12).max(6).default(-6),
    })
        .default({ enabled: false, preampDb: -6 }),
});
export const DbSchema = z.object({
    version: z.literal(6).default(6),
    tracks: z.array(TrackSchema).default([]),
    nextId: z.number().int().positive().default(1),
    config: DbConfigSchema.default({
        owners: [],
        halloweenMode: false,
        discord: { allowedChannelId: null },
        lastGitSyncAt: null,
        lastLibraryMutationAt: null,
        lastGitBackupAt: null,
        lastGitRestoreAt: null,
        normalization: { enabled: false, preampDb: -6 },
    }),
});
//# sourceMappingURL=db.js.map